import React from "react";
import { track } from "@herb/utils/analytics";

const AdventEmailSignup = ({ heading, text, buttonLabel, form, buttonLink }) => {
  const firstHalfOfHeadig = heading?.split(" ")?.slice(0, Math.ceil(heading?.split(" ")?.length / 2))?.join(" ");
  const secondHalfOfHeading = heading?.split(" ")?.slice(Math.ceil(heading?.split(" ")?.length / 2))?.join(" ");
  
  // Build URL with UTM parameters
  const buildUrlWithUTM = (url) => {
    if (!url || url === "#") return url;
    
    const utmParams = new URLSearchParams({
      utm_source: "herb-advent-calendar",
      utm_medium: "cta",
      utm_campaign: "advent-2025",
      utm_content: "email-signup"
    });
    
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}${utmParams.toString()}`;
  };

  const handleButtonClick = () => {
    // Track button click
    track("Advent Calendar Email Signup Click", {
      action: "Email Signup CTA",
      utm_source: "herb-advent-calendar",
      utm_medium: "cta",
      utm_campaign: "advent-2025",
      utm_content: "email-signup"
    });
  };

  return (
    <div className="AdventEmailSignup">
      <h2 className="AdvEmHeading"><span>{firstHalfOfHeadig}</span> <span>{secondHalfOfHeading}</span></h2>
      <div className="AdvEmText">{text}</div>
      <div className="AdvEmForm">
        {/* <input type="email" placeholder="Enter email" className="AdvEmInput" /> */}
        <a 
          href={buttonLink ? buildUrlWithUTM(buttonLink) : "#advent-calendar-main"} 
          target={buttonLink ? "_blank" : "_self"} 
          rel="noopener noreferrer" 
          className="AdvEmButton"
          onClick={handleButtonClick}
        >
          {buttonLabel}
        </a>
      </div>
    </div>
  );
};

export default AdventEmailSignup;
